import React, { Component } from 'react';
import TextField from '@mui/material/TextField';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import linkState from 'linkstate';
import './employee-dialog.css';
import LinearProgress from '@mui/material/LinearProgress';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import API from '../../../api/api';

const FireApi = new API();

class EmployeeDialog extends Component {
  constructor(props) {
    super(props);

    this.isAddMode = true;

    const userDefaults = {
      email: '',
      username: '',
      password: '',
      verified: 0,
      resettable: 1,
      force_logout: 0,
      groups: {},
    };

    let allGroups = [];
    let groupMap = {};
    let user = userDefaults;
    let isAddMode = true;

    if (props.userData) {
      isAddMode = false;
      const parsedGroups = this.parseGroupsFromPermissions(props.userData.groups || []);
      user = {
        ...props.userData,
        password: '',
        groups: parsedGroups,
      };
      const groupNamesFromPermissions = Object.keys(parsedGroups);
      if (groupNamesFromPermissions.length > 0) {
        allGroups = groupNamesFromPermissions.map(obj => ({
          object: obj,
          name: obj
        }));
        groupNamesFromPermissions.forEach(obj => {
          groupMap[obj] = obj;
        });
      }
    }

    this.isAddMode = isAddMode;
    this.state = {
      isAddMode,
      user,
      allGroups,
      groupMap,
      showPassword: false,
      loading: true,
    };
  }

  parseGroupsFromPermissions(permissions) {
    // Convert permissions array to groups object format
    // Permissions format: [{group_id: 2, type: "read", object: "calculates"}, ...]
    // Groups format: { "calculates": { "read": 1, "write": 1, "delete": 0 } }
    const groups = {};
    
    if (Array.isArray(permissions)) {
      permissions.forEach(perm => {
        const groupName = perm.object;
        if (groupName) {
          if (!groups[groupName]) {
            groups[groupName] = { read: 0, write: 0, delete: 0 };
          }
          if (perm.type === 'read') {
            groups[groupName].read = 1;
          } else if (perm.type === 'write') {
            groups[groupName].write = 1;
          } else if (perm.type === 'delete') {
            groups[groupName].delete = 1;
          }
        }
      });
    }
    
    return groups;
  }

  componentDidMount() {
    this.loadGroups();
  }

  loadGroups() {
    // Load groups from API
    FireApi.endpoints.groups.getAll({}, { page: 1, page_size: 500 })
      .then((groupsGet) => {
        let groups = [];
        if (groupsGet.data && groupsGet.data.results) {
          groups = groupsGet.data.results;
        } else if (Array.isArray(groupsGet.data)) {
          groups = groupsGet.data;
        } else if (groupsGet.data) {
          // If data is not an array, try to extract it
          groups = [groupsGet.data];
        }
        
        console.log('Groups API response:', groupsGet);
        console.log('Extracted groups:', groups);
        
        // Groups have structure: { object: "brightness", name: "Helligkeit" }
        // We need to use 'object' as the key (for API calls) and 'name' for display
        const groupMap = {};
        const uniqueGroups = [];
        
        groups.forEach(g => {
          if (g && g.object) {
            // Use object as the unique identifier
            if (!groupMap[g.object]) {
              groupMap[g.object] = g.name || g.object; // Use name if available, fallback to object
              uniqueGroups.push({
                object: g.object,
                name: g.name || g.object
              });
            }
          }
        });
        
        console.log('Group objects extracted:', uniqueGroups);
        console.log('Group map:', groupMap);
        
        // If no groups from API, try to extract from user's existing permissions
        let finalGroups = uniqueGroups;
        let finalGroupMap = groupMap;
        if (finalGroups.length === 0 && this.state.user && this.state.user.groups) {
          const groupNamesFromPermissions = Object.keys(this.state.user.groups);
          finalGroups = groupNamesFromPermissions.map(obj => ({
            object: obj,
            name: obj // Fallback to object name if display name not available
          }));
          finalGroupMap = {};
          groupNamesFromPermissions.forEach(obj => {
            finalGroupMap[obj] = obj;
          });
          console.log('Using groups from user permissions:', finalGroups);
        }
        
        this.setState({ 
          allGroups: finalGroups,
          groupMap: finalGroupMap,
          loading: false 
        });
      })
      .catch((error) => {
        console.error('Error loading groups:', error);
        // If groups endpoint fails, try to get from props or use empty array
        if (this.props.loadGroups) {
          this.props.loadGroups().then((groups) => {
            // Deduplicate groups from props as well
            const groupMap = {};
            const uniqueGroups = [];
            if (groups && Array.isArray(groups)) {
              groups.forEach(g => {
                if (g && g.object) {
                  if (!groupMap[g.object]) {
                    groupMap[g.object] = g.name || g.object;
                    uniqueGroups.push({
                      object: g.object,
                      name: g.name || g.object
                    });
                  }
                } else if (typeof g === 'string') {
                  if (!groupMap[g]) {
                    groupMap[g] = g;
                    uniqueGroups.push({
                      object: g,
                      name: g
                    });
                  }
                }
              });
            }
            this.setState({ 
              allGroups: uniqueGroups,
              groupMap: groupMap,
              loading: false 
            });
          }).catch(() => {
            this.setState({ loading: false });
          });
        } else {
          this.setState({ loading: false });
        }
      });
  }

  updateGroupPermission(groupName, permission, checked) {
    const newGroups = {
      ...this.state.user.groups,
    };
    
    if (!newGroups[groupName]) {
      newGroups[groupName] = { read: 0, write: 0, delete: 0 };
    }
    
    newGroups[groupName][permission] = checked ? 1 : 0;
    
    this.setState({
      user: {
        ...this.state.user,
        groups: newGroups,
      }
    });
  }

  render() {
    return (
      <div>
        <DialogTitle id="form-dialog-title">
          Benutzer {this.isAddMode ? "Hinzufügen" : "Bearbeiten"}
        </DialogTitle>
        {this.state.loading ? <LinearProgress color="primary" /> : <span className="loader-span"></span>}
        <DialogContent style={{ maxHeight: '70vh', overflowY: 'auto' }}>
          <div className="pt-line-one-parkings">
            <TextField
              autoFocus
              margin="dense"
              id="email"
              label="E-Mail Adresse"
              type="email"
              fullWidth
              variant="outlined"
              value={this.state.user.email}
              onInput={linkState(this, 'user.email')}
              required
            />
          </div>

          <div className="pt-line-one-parkings" style={{ marginTop: '20px' }}>
            <TextField
              margin="dense"
              id="username"
              label="Benutzername"
              type="text"
              fullWidth
              variant="outlined"
              value={this.state.user.username}
              onInput={linkState(this, 'user.username')}
            />
          </div>

          <div className="pt-line-one-parkings" style={{ marginTop: '20px' }}>
            <TextField
              margin="dense"
              id="password"
              label={this.isAddMode ? "Passwort" : "Neues Passwort (leer lassen zum Beibehalten)"}
              type={this.state.showPassword ? 'text' : 'password'}
              fullWidth
              variant="outlined"
              value={this.state.user.password}
              onInput={linkState(this, 'user.password')}
              required={this.isAddMode}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => this.setState({ showPassword: !this.state.showPassword })}
                      edge="end"
                    >
                      {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div>

          <div style={{ display: 'flex', gap: '15px', marginTop: '20px', flexWrap: 'wrap' }}>
            <FormControlLabel
              control={
                <Switch
                  checked={this.state.user.verified === 1}
                  onChange={(e) => this.setState({
                    user: { ...this.state.user, verified: e.target.checked ? 1 : 0 }
                  })}
                  color="primary"
                />
              }
              label="Verifiziert"
            />
            <FormControlLabel
              control={
                <Switch
                  checked={this.state.user.resettable === 1}
                  onChange={(e) => this.setState({
                    user: { ...this.state.user, resettable: e.target.checked ? 1 : 0 }
                  })}
                  color="primary"
                />
              }
              label="Passwort zurücksetzbar"
            />
            <FormControlLabel
              control={
                <Switch
                  checked={this.state.user.force_logout === 1}
                  onChange={(e) => this.setState({
                    user: { ...this.state.user, force_logout: e.target.checked ? 1 : 0 }
                  })}
                  color="primary"
                />
              }
              label="Abmeldung erzwingen"
            />
          </div>

          {!this.isAddMode && (
            <div style={{ marginTop: '20px', padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
              <div style={{ fontSize: '12px', color: '#666', marginBottom: '5px' }}>
                Registriert: {this.state.user.registered 
                  ? new Date(this.state.user.registered * 1000).toLocaleString('de-DE')
                  : '-'}
              </div>
              <div style={{ fontSize: '12px', color: '#666' }}>
                Letzter Login: {this.state.user.last_login 
                  ? new Date(this.state.user.last_login * 1000).toLocaleString('de-DE')
                  : 'Nie'}
              </div>
            </div>
          )}

          <div style={{ marginTop: '30px' }}>
            <Typography variant="h6" style={{ marginBottom: '15px', fontSize: '16px', fontWeight: 'bold' }}>
              Gruppenberechtigungen
            </Typography>
            {this.props.currentUserId && this.state.user.id && this.props.currentUserId === this.state.user.id && (
              <div style={{ 
                padding: '10px', 
                marginBottom: '15px', 
                backgroundColor: '#fff3cd', 
                color: '#856404',
                borderRadius: '4px',
                fontSize: '14px'
              }}>
                ⚠️ Sie können Ihre eigenen Berechtigungen nicht ändern.
              </div>
            )}
            <TableContainer component={Paper} style={{ maxHeight: '60vh', overflowY: 'auto', overflowX: 'auto', width: '100%' }}>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell>Gruppe</TableCell>
                    <TableCell align="center">Read</TableCell>
                    <TableCell align="center">Write</TableCell>
                    <TableCell align="center">Delete</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.allGroups.length > 0 ? (
                    this.state.allGroups.map((group) => {
                      const groupObject = group.object || group; // Support both object format and string
                      const groupName = group.name || groupObject; // Display name
                      const groupPermissions = this.state.user.groups[groupObject] || { read: 0, write: 0, delete: 0 };
                      const isOwnUser = this.props.currentUserId && this.state.user.id && this.props.currentUserId === this.state.user.id;
                      return (
                        <TableRow key={groupObject}>
                          <TableCell component="th" scope="row">
                            {groupName}
                          </TableCell>
                        <TableCell align="center">
                          <Checkbox
                            checked={groupPermissions.read === 1}
                            onChange={(e) => this.updateGroupPermission(groupObject, 'read', e.target.checked)}
                            color="primary"
                            disabled={isOwnUser}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Checkbox
                            checked={groupPermissions.write === 1}
                            onChange={(e) => this.updateGroupPermission(groupObject, 'write', e.target.checked)}
                            color="primary"
                            disabled={isOwnUser}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Checkbox
                            checked={groupPermissions.delete === 1}
                            onChange={(e) => this.updateGroupPermission(groupObject, 'delete', e.target.checked)}
                            color="primary"
                            disabled={isOwnUser}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  }))
                  : (
                    <TableRow>
                      <TableCell colSpan={4} align="center" style={{ padding: '20px' }}>
                        {this.state.loading ? 'Lade Gruppen...' : 'Keine Gruppen verfügbar'}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </DialogContent>
        <DialogActions>
          <div className="p-line-end">
            <Button variant="outlined" onClick={this.props.close}>
              Abbrechen
            </Button>
            <span></span>
            <Button 
              variant="contained" 
              color="primary" 
              onClick={() => { 
                this.props.submit({
                  isAddMode: this.isAddMode,
                  user: this.state.user
                }); 
              }}
            >
              Speichern
            </Button>
          </div>
        </DialogActions>
      </div>
    );
  }
}

export default EmployeeDialog;
